/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
import Vue from "vue";
import PortalVue from "portal-vue";
import CollapseTransition from "@ivanv/vue-collapse-transition";
import VueFullPage from "vue-fullpage.js";
import vmodal from "./vendor/vue-js-modal";
import vClickOutside from "v-click-outside";
import VueChart from "vue-chart-js";
import VueScreen from "vue-screen";
import AnimatedNumber from "animated-number-vue";

window.axios = require('axios');

Vue.component("collapse-transition", CollapseTransition);
Vue.component("animated-number", AnimatedNumber);

Vue.use(VueScreen);
Vue.use(VueFullPage);
Vue.use(PortalVue);
Vue.use(vmodal);
Vue.use(vClickOutside);
Vue.use(VueChart);

window.Event = new Vue();

/**
 * The following block of code used to automatically register
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */
const files = require.context("./", true, /\.vue$/i);
files.keys().map(key =>
    Vue.component(
        key
            .split("/")
            .pop()
            .split(".")[0],
        files(key).default
    )
);

new Vue({
    el: "#app"
});
